import { LOG_LEVELS } from 'ia-react-core';
import { error } from './error';
import { log } from './log';
import { DocumentAdditionalInformations } from './interfaces/DocumentAdditionalInformations';

class OmniLogging {
  private static ApiLogLevel: { [key: string]: string } = this.Init();
  private static Init(): { [key: string]: string } {
    const temp: { [key: string]: string } = {};
    temp[LOG_LEVELS.DEBUG] = 'debug';
    temp[LOG_LEVELS.ERROR] = 'error';
    temp[LOG_LEVELS.INFO] = 'information';
    temp[LOG_LEVELS.LOG] = 'information';
    temp[LOG_LEVELS.WARN] = 'warning';
    return temp;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private static isDocumentAdditionalInformations(object: any): object is DocumentAdditionalInformations {
    return 'id' in object;
  }

  /* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */
  static log(ns: string, level: string, ...args: any[]): void {
    const message = args[0].toString();
    let id: string = null;
    let correlationId: string = null;
    let slice = 1;
    if (args.length > 1 && this.isDocumentAdditionalInformations(args[1])) {
      const addInfos: DocumentAdditionalInformations = args[1];
      id = addInfos.id;
      correlationId = addInfos.correlationId;
      slice = 2;
    }
    const details = { namespace: ns, args: args.slice(slice) };

    if (level === LOG_LEVELS.ERROR) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      error(OmniLogging.ApiLogLevel[level], { message, details }, message, details, id, correlationId);
    } else {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      log(OmniLogging.ApiLogLevel[level], message, details, id, correlationId);
    }
  }
  /* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */
}

export default OmniLogging;
